import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, TouchableOpacity, Platform } from 'react-native';
import { Text } from '../components';

class LandingSliders extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {
    return (
      <View style={styles.slider_container}>
        <Text style={styles.slider_text}>SUBSCRIPTION</Text>
        <Text style={styles.slider_text}>INFO</Text>
        <Text style={styles.slider_text}>SLIDERS</Text>
      </View>
    );
  }

}

const styles = StyleSheet.create({
  slider_container: {
    backgroundColor: 'pink',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
  },
  slider_text: {
    fontSize: 20,
    fontWeight: '500',
    color: 'white',
    marginBottom: 5
  }
});

export default LandingSliders
